import axiosInstance from "./AxiosInstance";

/* ---------------------- LOCATION APIs ---------------------- */
export function getAllLocations(params = {}) {
  const config = {
    params,
  };

  if (params.export) {
    config.responseType = "blob"; // Expect file download (CSV)
  }

  return axiosInstance.get("api/setting/location/", config);
}

export function getLocationById(id) {
  return axiosInstance.get("api/setting/location/", { params: { id } });
}

export function createLocation(data) {
  return axiosInstance.post("api/setting/location/", data);
}

export function updateLocation(id, data) {
  return axiosInstance.put(`api/setting/location/?id=${id}`, data);
}

export function deleteLocation(id) {
  return axiosInstance.delete(`api/setting/location/?id=${id}`);
}
export function uploadLocationExcel(file) {
  const formData = new FormData();
  formData.append("file", file);
  return axiosInstance.post("api/setting/location/upload/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}


/* ---------------------- DEPARTMENT APIs ---------------------- */
export function getAllDepartments(params = {}) {
  return axiosInstance.get("api/setting/department/", { params });
}

export function getDepartmentById(id) {
  return axiosInstance.get("api/setting/department/", { params: { id } });
}

export function createDepartment(data) {
  return axiosInstance.post("api/setting/department/", data);
}

export function updateDepartment(id, data) {
  return axiosInstance.put(`api/setting/department/?id=${id}`, data);
}

export function deleteDepartment(id) {
  return axiosInstance.delete(`api/setting/department/?id=${id}`);
}
export function uploadDepartmentExcel(file) {
  const formData = new FormData();
  formData.append("file", file);
  return axiosInstance.post("api/setting/department/upload/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

/* ---------------------- DESIGNATION APIs ---------------------- */
export function getAllDesignations(params = {}) {
  return axiosInstance.get("api/setting/designation/", { params });
}

export function getDesignationById(id) {
  return axiosInstance.get("api/setting/designation/", { params: { id } });
}

export function createDesignation(data) {
  return axiosInstance.post("api/setting/designation/", data);
}

export function updateDesignation(id, data) {
  return axiosInstance.put(`api/setting/designation/?id=${id}`, data);
}

export function deleteDesignation(id) {
  return axiosInstance.delete(`api/setting/designation/?id=${id}`);
}
export function uploadDesignationExcel(file) {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance.post("api/setting/designation/upload/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

/*-----------------------AREA-------------------------*/

export function getAllAreas(param) {
  const params = new URLSearchParams(param).toString();
  const isExport = param?.export === true || param?.export === "true";

  return axiosInstance.get(`api/setting/area?${params}`, {
    responseType: isExport ? "blob" : "json",
  });
}

export function createArea(data) {
  return axiosInstance.post(`api/setting/area`, data);
}
export function updateArea(areaId, data) {
  return axiosInstance.put(`api/setting/area/${areaId}`, data);
}
export function uploadAreaExcel(file) {
  const formData = new FormData();
  formData.append("file", file);
  return axiosInstance.post("api/setting/area/upload/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}